/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Search_Where_LabelInputs */

const en_home_search_where_label = /** @type {(inputs: Home_Search_Where_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Where`)
};

/**
* | output |
* | --- |
* | "Where" |
*
* @param {Home_Search_Where_LabelInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const home_search_where_label = /** @type {((inputs?: Home_Search_Where_LabelInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Search_Where_LabelInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_home_search_where_label(inputs)
});